import { useContext, useEffect, useState } from "react";
import { Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import Loader from "../../components/Loader";
import { ProfileContext } from "../../context/ProfileContext";

function CallRate() {
  const { isLoading, getCallRateData, updateCallRateData } = useContext(ProfileContext);
  const [baseCost, setBaseCost] = useState(0);
  const { register, handleSubmit, formState: { errors }, setValue, watch } = useForm({
    defaultValues: {
      serviceCharges: 0,
      consultationCharges: 0,
      taxes: 0,
      chargeAmount: 0
    }
  });
  const serviceCharges = watch("serviceCharges");
  const consultationCharges = watch("consultationCharges");
  const taxes = watch("taxes");

  const chargeAmount = Number(serviceCharges || 0) + Number(consultationCharges || 0) + Number(taxes || 0);
  useEffect(() => { fetchCallRate() }, []);

  const fetchCallRate = async () => {
    const data = await getCallRateData();
    if (data) {
      setBaseCost(data.baseCost || 0);

      setValue("serviceCharges", data.serviceCharges || 0);
      setValue("consultationCharges", data.consultationCharges || 0);
      setValue("taxes", data.taxes || 0);
      setValue("chargeAmount", data.callChargeAmount || 0);
    }
  };

  const handleSave = async (data) => {
    if (data.chargeAmount === '' || data.chargeAmount < 0) { return }
    await updateCallRateData({
      serviceCharges: Number(data.serviceCharges),
      consultationCharges: Number(data.consultationCharges),
      taxes: Number(data.taxes),
      callChargeAmount: Number(data.chargeAmount)
    });
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <div className="container-fluid">
        <Header />
        <div className="row">
          <Sidebar />
          <div className="col-9 main-dash-left">
            <section className="back-dashboard-sec comn-dashboard-page">
              <div className="notifi-list d-flex justify-content-between align-items-center">
                <h6 className="comm_page_heading">Call Rates Settings</h6>
                <p className="comm_page_sub_heading">Manage the amount charged to users for each HeyGen call.</p>
              </div>

              <div className="row mt-4">
                <div className="col-md-6 offset-md-3">
                  <div className="card shadow-sm border-0" style={{ borderRadius: "15px" }}>
                    <div className="card-body p-5">
                      <div className="text-center mb-5">
                        <h2 className="fw-bold mb-2">Configuration</h2>
                        <p className="text-muted">Set the call rate per session</p>
                      </div>

                      <div className="mb-5 p-4 bg-light rounded d-flex justify-content-between align-items-center">
                        <div>
                          <span className="fw-semibold text-secondary fs-3">Base Cost</span>
                          <div className="text-muted mt-1 fs-4">Calculated platform cost</div>
                        </div>
                        <h3 className="mb-0 text-dark fw-bold">${Number(baseCost).toFixed(2)}</h3>
                      </div>

                      <Form onSubmit={handleSubmit(handleSave)}>
                        <Form.Group className="mb-5">
                          <Form.Group className="comn-class-inputs">
                            <Form.Label className="fs-3 fw-bold">Service Charges ($)</Form.Label> &nbsp; <span className="fs-5 fw-semibold">(Hygen and AWS fee)</span>
                            <Form.Control type="number" step="0.01"
                              {...register("serviceCharges", { required: "Service Charges is required", min: 0, max: 100 })}
                            />
                            <Form.Control.Feedback type="invalid" className="fs-4">{errors.serviceCharges?.message}</Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group className="comn-class-inputs">
                            <Form.Label className="fs-3 fw-bold">Consultation Charges ($)</Form.Label>
                            <Form.Control type="number" step="0.01"
                              {...register("consultationCharges", { required: "Consultation Charges is required", min: 0, max: 100 })}
                            />
                            <Form.Control.Feedback type="invalid" className="fs-4">{errors.consultationCharges?.message}</Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group className="comn-class-inputs">
                            <Form.Label className="fs-3 fw-bold">Taxes ($)</Form.Label>
                            <Form.Control type="number" step="0.01"
                              {...register("taxes", { required: "Taxes is required", min: 0, max: 100 })}
                            />
                            <Form.Control.Feedback type="invalid" className="fs-4">{errors.taxes?.message}</Form.Control.Feedback>
                          </Form.Group>

                          <Form.Group className="comn-class-inputs">
                            <Form.Label className="fw-bold fs-3">Total Charge Amount ($)</Form.Label>
                            <Form.Control type="number" value={chargeAmount.toFixed(2)} readOnly className="fs-4 bg-light" />
                            <Form.Text className="text-muted mt-3 d-block fs-5">Service Charges + Consultation Charges + Taxes</Form.Text>
                          </Form.Group>
                        </Form.Group>
                        <div className="d-grid mt-5">
                          <Button type="submit" className="rounded-pill fw-bold fs-3"
                            style={{ background: "linear-gradient(135deg, #005BE4, #1A76EA)", border: "none", padding: "15px" }}
                          >
                            Save Configuration
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default CallRate;
